<template>
  <div v-if="getAppLoading" class="h-[500px] flex justify-center items-center">
    <app-loader></app-loader>
  </div>
  <div v-else>
    <v-sheet max-width="" class="bg-transparent mt-n5 mb-7">
      <v-row class="justify-space-between">
        <v-col>
          <div
            class="flex items-center h-full text-xl font-semibold leading-7 text-left text-gray-900 font-inter"
          >
            {{ $t("requestFundsTab.period") }}
          </div>
        </v-col>
        <v-col cols="2">
          <div></div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <app-date-picker
            id="start-date"
            :label="$t('leaves.startDate')"
            type="date"
            v-model="startDate"
            :disabled="!isEditButton"
            :min="startDate"
            :max="endDate"
          >
          </app-date-picker>
        </v-col>
        <v-col cols="2">
          <app-date-picker
            id="end-date"
            :label="$t('leaves.endDate')"
            type="date"
            v-model="endDate"
            :disabled="!isEditButton"
            :min="startDate"
            :max="endDate"
          >
          </app-date-picker>
        </v-col>
      </v-row>

      <v-row class="pa-0 mt-7">
        <v-col>
          <div>
            <funds-table
              mode="add"
              :overViewData="isEditMode ? getRequestedFundData?.funds : getRequestedFundsStats.funds"
            ></funds-table>
          </div>
        </v-col>
      </v-row>
      <v-row class="pa-0 mt-7">
        <v-col>
          <div>
            <budget-item-table
              mode="add"
              :data="getRequestedFundsStats.request_items"
              :tableStats="tableStats"
            ></budget-item-table>
          </div>
        </v-col>
      </v-row>
      <v-row class="justify-end pa-0 mt-7">
        <v-col cols="1">
          <div>
            <app-secondary-button
              :buttonLabel="$t('education.cancel')"
              @click="hideTab()"
            >
            </app-secondary-button>
          </div>
        </v-col>
        <v-col cols="1">
          <div>
            <app-primary-button
              :buttonLabel="isEditMode ? $t('Update'?.getTranslationKey()) : $t('requestFundsTab.submit')"
              @click="showDialog"
            >
            </app-primary-button>
          </div>
        </v-col>
      </v-row>
    </v-sheet>
    <app-dialog
      ref="dialogState"
      :title="$t('requestFundsTab.requestFund')"
      subTitle=""
      :width="1250"
      persistent
    >
      <template #content>
        <table class="mb-5">
          <tr>
            <td class="font-semibold pt-1">
              {{ $t("requestFundsTab.costCenter") }}
            </td>
            <td class="pt-1">
              <span class="font-semibold px-1"> :</span>

              <span>
                {{ getRequestedFundsStatsModalData?.cost_centre }}
              </span>
            </td>
          </tr>
          <tr>
            <td class="font-semibold pt-1">
              {{ $t("requestFundsTab.title") }}
            </td>
            <td class="pt-1">
              <span class="font-semibold px-1"> :</span>

              <span>
                {{ getRequestedFundsStatsModalData?.project_title }}
              </span>
            </td>
          </tr>
          <tr>
            <td class="font-semibold pt-1">
              {{ $t("requestFundsTab.location") }}
            </td>
            <td class="pt-1">
              <span class="font-semibold px-1"> :</span>

              <span>
                {{ getRequestedFundsStatsModalData?.location?.country }},
                {{ getRequestedFundsStatsModalData?.location?.place }}
              </span>
            </td>
          </tr>
          <tr>
            <td class="font-semibold pt-1">
              {{ $t("requestFundsTab.period") }}
            </td>
            <td class="pt-1">
              <span class="font-semibold px-1"> :</span>

              <span>
                {{ formatDate(startDate) }} - {{ formatDate(endDate) }}
              </span>
            </td>
          </tr>
        </table>
        <v-sheet max-width="" class="bg-transparent">
          <funds-table
            v-if="getIsFundTable"
            mode="view"
            :overViewData="getRequestedFundsStats.funds"
          ></funds-table>
          <budget-item-table
            v-else
            mode="view"
            :data="requestItems"
            :tableStats="tableStats"
          ></budget-item-table>

          <BaseBankDetails
            :tableObject="bankDetails"
          />

          <v-row class="pa-0 mt-4">
            <v-col cols="4">
              <div>
                <div>
                  <div class="flex flex-col items-left mt-0">
                    <div
                      class="h-[60px] border-b border-dotted border-gray-900 w-2/4 p-0 flex justify-left items-center bg-white"
                    >
                      <img
                        :src="imageUrl"
                        alt=""
                        class="max-h-[60px] min-w-[100px] max-w-[200px]"
                        v-if="showSignature"
                      />
                      <p
                        @click="signOrUpload"
                        class="text-[#8B2923] text-sm cursor-pointer"
                        v-if="!showSignature"
                      >
                        {{ $t("requestFundsTab.clickToSign") }}
                      </p>
                    </div>
                  </div>
                  <input
                    type="file"
                    @change="handleFileUpload"
                    style="display: none"
                    ref="fileInput"
                    accept="image/*"
                  />
                </div>
                <div
                  class="text-gray-700  font-semibold leading-7 h-[30px] w-2/4 p-0 flex justify-left mt-2"
                >
                  {{
                    getRequestedFundsStatsModalData?.requester_signature?.title
                  }}
                  {{
                    getRequestedFundsStatsModalData?.requester_signature
                      ?.last_name
                  }}
                  {{
                    getRequestedFundsStatsModalData?.requester_signature
                      ?.first_name
                  }}
                </div>
                <div
                  class="text-gray-700 text-sm font-semibold leading-7 h-[40px] border-b border-dotted border-gray-900 w-2/4 p-0 flex justify-left"
                >
                  <app-date-picker
                    id="requester_signature_date"
                    v-model="signatureDate"
                  >
                  </app-date-picker>
                </div>
              </div>
            </v-col>
            <v-col
              cols="4"
              v-if="
                getRequestedFundsStatsModalData?.offer_controller?.last_name
              "
            >
              <div>
                <div>
                  <div class="flex flex-col items-left mt-0">
                    <div
                      class="h-[60px] border-b border-dotted border-gray-900 w-2/4 p-0 flex justify-left items-center bg-white"
                    ></div>
                  </div>
                </div>
                <div
                  class="text-gray-700 font-semibold leading-7 h-[30px] w-2/4 p-0 flex justify-left mt-2"
                >
                  {{ getRequestedFundsStatsModalData?.offer_controller?.title }}
                  {{
                    getRequestedFundsStatsModalData?.offer_controller?.last_name
                  }}
                  {{
                    getRequestedFundsStatsModalData?.offer_controller
                      ?.first_name
                  }}
                </div>
                <div
                  class="text-gray-700 text-sm font-semibold leading-7 h-[40px] border-b border-dotted border-gray-900 w-2/4 p-0 flex justify-left"
                >
                  <app-date-picker
                    id="controller_signature_date"
                    v-model="signatureDate"
                  >
                  </app-date-picker>
                </div>
              </div>
            </v-col>
            <v-col
              cols="4"
              v-if="getRequestedFundsStatsModalData?.project_manager?.last_name"
            >
              <div>
                <div>
                  <div class="flex flex-col items-left mt-0">
                    <div
                      class="h-[60px] border-b border-dotted border-gray-900 w-2/4 p-0 flex justify-left items-center bg-white"
                    ></div>
                  </div>
                </div>
                <div
                  class="text-gray-700 font-semibold leading-7 h-[30px] w-2/4 p-0 flex justify-left mt-2"
                >
                  {{ getRequestedFundsStatsModalData?.project_manager?.title }}
                  {{
                    getRequestedFundsStatsModalData?.project_manager?.last_name
                  }}
                  {{
                    getRequestedFundsStatsModalData?.project_manager?.first_name
                  }}
                </div>
                <div
                  class="text-gray-700 text-sm font-semibold leading-7 h-[40px] border-b border-dotted border-gray-900 w-2/4 p-0 flex justify-left"
                >
                  <app-date-picker
                    id="project_manager_signature_date"
                    v-model="signatureDate"
                  >
                  </app-date-picker>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-sheet>
      </template>
      <template #actions>
        <v-row class="flex justify-end px-4 mt-1 mb-5">
          <v-col cols="1" class="">
            <app-secondary-button
              :buttonLabel="$t('employees.cancel')"
              @click="hideDialog()"
              class="cursor-pointer"
            >
            </app-secondary-button>
          </v-col>
          <v-col cols="2" class="">
            <app-primary-button
              :buttonLabel="$t('requestFundsTab.sendforApproval')"
              @click="submit"
              class="cursor-pointer"
              :loading="requesting"
            >
            </app-primary-button>
          </v-col>
        </v-row>
      </template>
    </app-dialog>
    <app-dialog
      ref="dialogUploadState"
      width="586"
      height="800"
      :title="$t('contracts.cropAnduploadSiganture')"
      :subtitle="``"
      persistent
    >
      <template #content>
        <VueCropper
          v-if="selectedFile"
          ref="cropper"
          :src="imageUrl"
          view-mode="1"
          :guides="true"
          :auto-crop="true"
          :auto-crop-area="0.5"
          :movable="true"
          :zoomable="true"
          :drag-mode="'crop'"
          :data="{ width: 400, height: 400 }"
        ></VueCropper>
      </template>
      <template #actions>
        <v-row class="px-4 mt-1 mb-5">
          <v-col cols="6">
            <app-secondary-button
              :buttonLabel="$t('projects.cancel')"
              @click-event="cancelUpload()"
            >
            </app-secondary-button>
          </v-col>
          <v-col cols="6">
            <app-primary-button
              :buttonLabel="$t('contracts.uploadSignature')"
              :loading="isLoading"
              @click-event="cropImage()"
            >
            </app-primary-button>
          </v-col>
        </v-row>
      </template>
    </app-dialog>
    <app-alert
      :title="$t(getTranslatedStringKey(alertTitle))"
      @close-alert="alertState = false"
      :state="alertState"
      :timeout="5000"
      :type="alertType"
    />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import FundsTable from "./requestedFunds/FundsTable.vue";
import BudgetItemTable from "./requestedFunds/BudgetItemTable.vue";
import { mapActions, mapGetters } from "vuex";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { getTransString } from "@/services/helpers";
import API from "@/services/api";
import { uploadEmployeeSignature } from "@/services/endpoints";
import { isEqual } from "lodash";
import BaseBankDetails from "@/components/shared/BaseBankDetails.vue";

export default defineComponent({
  name: "RequestNewFund",
  components: {
    FundsTable,
    BudgetItemTable,
    VueCropper,
    BaseBankDetails,
  },
  data() {
    return {
      startDate: new Date().toISOString().slice(0, 10),
      endDate: new Date().toISOString().slice(0, 10),
      signatureDate: new Date().toISOString().slice(0, 10),
      dialogState: true,
      dialogUploadState: false,
      imageUrl: null,
      selectedFile: null,
      alertType: "success",
      alertState: false,
      alertTitle: "",
      showSignature: false,
      initialRequestedFundsBody: {
        start_date: null,
        end_date: null,
        project_funds: [],
        requester_signature: null,
      },
      timeoutId: null,
      requesting: false,
    };
  },
  computed: {
    ...mapGetters("pmLocalRequestFund", [
      "getAppLoading",
      "getRequestedFundsStats",
      "getIsFundTable",
      "getRequestedFundData"
    ]),
    isEditMode() {
      return this.$store.getters["pmLocalRequestFund/isEditMode"];
    },
    currentTab() {
      return this.$store.getters["commonResources/isCurrentTab"];
    },
    getRequestedFundsResponse() {
      return this.$store.getters["pmLocalRequestFund/getResponse"];
    },
    getRequestedFundsStatsModalData() {
      return this.getRequestedFundsStats?.model_data;
    },
    bankDetails() {
      return {
        account_title: this.getRequestedFundsStatsModalData?.account_owner,
        bank_address: this.getRequestedFundsStatsModalData?.city_of_bank,
        account_number: this.getRequestedFundsStatsModalData?.account_number,
        bank_name: this.getRequestedFundsStatsModalData?.bank_name,
        swift_code: this.getRequestedFundsStatsModalData?.swift_code,
        iban: this.getRequestedFundsStatsModalData?.iban,
        sort_code: this.getRequestedFundsStatsModalData?.sort_code,
        bank_country: this.getRequestedFundsStatsModalData?.country_of_bank
      }
    },
    signature() {
      return this.getRequestedFundsStatsModalData?.requester_signature
        ?.signature;
    },
    getRequestedFundsError() {
      return this.$store.getters["pmLocalRequestFund/getError"];
    },
    foreignEstablishment() {
      return this.$store.getters["pmLocalModules/isForeignEstablishmentID"];
    },
    tableStats() {
      return {
        total_planned_amount: this.getRequestedFundsStats.total_planned_amount,
        total_remaining_amount: this.getRequestedFundsStats.total_ramaining_amount,
        total_requested_amount: this.getRequestedFundsStats.total_requested_amount,
      };
    },
    requestItems() {
      return this.getRequestedFundsStats.request_items;
    },
    isEditButton() {
      return this.$store.getters["hrResources/isEditButton"];
    },
    isContractDetails() {
      return this.$store.getters["projectModules/isContractDetails"];
    },
  },
  watch: {
    startDate: {
      handler: function (val) {
        this.$store.commit(
          "pmLocalRequestFund/SET_REQUESTED_FUNDS_BODY_START_DATE",
          val
        );
      },
      deep: true,
    },
    endDate: {
      handler: function (val) {
        this.$store.commit(
          "pmLocalRequestFund/SET_REQUESTED_FUNDS_BODY_END_DATE",
          val
        );
      },
      deep: true,
    }
  },
  methods: {
    ...mapActions("pmLocalRequestFund", [
      "fetchRequestedFundStats",
      "saveRequestedFund",
    ]),
    hideTab() {
      this.$store.commit("pmLocalModules/SET_SHOW_REQUEST_NEW_FUND", false);
      this.$store.commit("commonResources/SET_CURRENT_TAB_TO_STATE", this.currentTab - 1);
    },

    async submit() {
      try {
        this.requesting = true;
        await this.saveRequestedFund({
          foreignEstablishment: this.foreignEstablishment,
        });
        this.alertType = this.getRequestedFundsResponse.status;
        this.alertState = true;
        this.alertTitle = this.getRequestedFundsResponse.detail;

        if ("data" in this.getRequestedFundsError) {
          this.alertType = "error";

          if ("requester_signature" in this.getRequestedFundsError.data) {
            this.alertTitle =
              "Your Signature is required to submit the request.";
          }

          if ("start_date" in this.getRequestedFundsError.data) {
            this.alertTitle = "Please select a start date";
          }

          if ("end_date" in this.getRequestedFundsError.data) {
            this.alertTitle = "Please select an end date";
          }

          if ("status" in this.getRequestedFundsError.data) {
            this.alertTitle = this.getRequestedFundsError.data.detail;
          }
          return;
        }
        this.$store.commit("pmLocalRequestFund/RE_SET_REQUESTED_FUNDS_BODY");

        if(this.timeoutId) {
          clearTimeout(this.timeoutId);
        }

        this.timeoutId = setTimeout(() => {
          this.hideTab();
        }, 500);
      } catch (error) {
        this.alertType = "error";
        // this.alertState = !this.alertState;
        // this.alertTitle = error?.message;
      } finally {
        this.requesting = false;
      }
    },
    showDialog() {
      this.$refs.dialogState.showDialog = true;
      this.$store.commit(
        "pmLocalRequestFund/SET_REQUESTED_FUNDS_BODY_REQUESTER_SIGNATURE",
        ""
      );
    },
    hideDialog() {
      this.$refs.dialogState.showDialog = false;
      this.imageUrl = null;
      this.showSignature = false;
    },
    getTranslatedStringKey(field) {
      return getTransString(field);
    },
    openFileInput() {
      this.showSignature = true;
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      const validateImageType = ["image/jpeg", "image/png", "image/jpg"];
      if (!validateImageType.includes(file.type)) {
        this.alertType = "error";
        this.alertState = true;
        this.alertTitle = "Please upload a valid image file.";
        return;
      }
      this.selectedFile = file;
      this.imageUrl = URL.createObjectURL(file);
      // this.uploadImage();
      this.$refs.dialogUploadState.showDialog = true;
    },
    cropImage() {
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        this.selectedFile = new File([blob], "cropped-image.jpg", {
          type: "image/jpeg",
        });
        this.imageUrl = URL.createObjectURL(this.selectedFile);
        this.uploadImage();
      }, "image/jpeg");
      this.$refs.dialogUploadState.showDialog = false;
    },
    clearImage() {
      this.imageUrl = null;
      this.$refs.fileInput.value = "";
      this.selectedFile = null;
      this.$refs.dialogUploadState.showDialog = false;
      this.deleteSignature();
    },
    cancelUpload() {
      this.imageUrl = null;
      this.$refs.fileInput.value = "";
      this.selectedFile = null;
      this.$refs.dialogUploadState.showDialog = false;
      this.showSignature = false;
    },
    uploadImage() {
      if (!this.selectedFile) {
        alert("Please select an image to upload.");
        return;
      }

      const formData = new FormData();
      formData.append("signature", this.selectedFile);
      API()
        .post("/projects/pm_local/upload-expert-signature/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (response) => {
          if (response.data.status === "success") {
            this.alertType = "success";
            this.alertState = true;
            this.alertTitle = response?.data?.detail;

            const signatureUrl = response?.data?.data?.file_path;

            this.$store.commit(
              "pmLocalRequestFund/SET_REQUESTED_FUNDS_BODY_REQUESTER_SIGNATURE",
              signatureUrl
            );
          }
        })
        .catch((error) => {
          if (error) {
            this.alertType = "error";
            this.alertState = true;
            this.alertTitle = "Error uploading image. Please try again.";
          }
        });
    },
    formatDate(inputDate) {
      if (!inputDate) {
        return "";
      }
      // Parse the input date
      const dateParts = inputDate?.split("-");
      const year = parseInt(dateParts[0]);
      const month = parseInt(dateParts[1]);
      const day = parseInt(dateParts[2]);

      // Format the date as "dd.mm.yyyy"
      const formattedDate = `${day}.${month}.${year}`;

      return formattedDate;
    },
    signOrUpload() {
      if (this.signature) {
        this.imageUrl = this.signature;
        this.$store.commit(
          "pmLocalRequestFund/SET_REQUESTED_FUNDS_BODY_REQUESTER_SIGNATURE",
          this.signature
        );
        this.showSignature = true;
      } else {
        this.openFileInput();
      }
    },
  },
  created() {
    this.$store.commit("pmLocalRequestFund/RE_SET_REQUESTED_FUNDS_BODY");
  },
  async mounted() {
    await this.fetchRequestedFundStats({
      foreignEstablishment: this.foreignEstablishment,
    });

    //request fund within project start and end date
    this.startDate =
      this.isContractDetails.project__project_start_date ||
      new Date().toISOString().slice(0, 10);
    this.endDate =
      this.isContractDetails.project__project_end_date ||
      new Date().toISOString().slice(0, 10);

    this.initialRequestedFundsBody.start_date = this.startDate;
    this.initialRequestedFundsBody.end_date = this.endDate;
    this.$store.commit(
      "pmLocalRequestFund/SET_REQUESTED_FUNDS_BODY_START_DATE",
      this.startDate
    );
    this.$store.commit(
      "pmLocalRequestFund/SET_REQUESTED_FUNDS_BODY_END_DATE",
      this.endDate
    );
  },
  beforeUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  },
});
</script>
<style scoped></style>
